import { useWallet as useSolanaWallet } from '@solana/wallet-adapter-react';

/**
 * useWallet Hook - Simplified wallet connection interface
 *
 * Provides easy access to wallet state and methods:
 * - wallet: Current wallet adapter
 * - connected: Connection status
 * - connecting: Connection in progress
 * - publicKey: User's public key (wallet address)
 * - connect/disconnect: Connection methods
 *
 * This hook abstracts the Solana wallet adapter and can be easily
 * replaced or modified without changing components that use it.
 */
export function useWallet() {
    const {
        wallet,
        connected,
        connecting,
        disconnecting,
        publicKey,
        connect,
        disconnect,
        select,
        wallets,
    } = useSolanaWallet();

    /**
     * Format public key to shortened address format
     * Example: 7a3f...9d2e
     */
    const getShortAddress = () => {
        if (!publicKey) return null;
        const address = publicKey.toBase58();
        return `${address.slice(0, 4)}...${address.slice(-4)}`;
    };

    /**
     * Get full address as base58 string
     */
    const getFullAddress = () => {
        if (!publicKey) return null;
        return publicKey.toBase58();
    };

    return {
        wallet,
        connected,
        connecting,
        disconnecting,
        publicKey,
        address: getFullAddress(),
        shortAddress: getShortAddress(),
        connect,
        disconnect,
        select,
        wallets,
    };
}
